import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AccSimpleInputTextFormControlInterface } from '../acc-simple-input-text-form.component';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { combineLatest, Subscription, startWith, finalize } from 'rxjs';

@Component({
  selector: 'app-simple-form-date-range-input',
  templateUrl: './simple-form-date-range-input.component.html',
  styleUrls: ['./simple-form-date-range-input.component.scss']
})
export class SimpleFormDateRangeInputComponent implements OnInit {

  @Input({ required: true }) public parentFormGroup!: FormGroup;
  @Input({ required: true }) public controlInfo!: AccSimpleInputTextFormControlInterface;
  @Input({ required: true }) public controlId!: string | number;

  public formGroup!: FormGroup;

  public get getDateRangeInvalid() {
    const formGroup = this.formGroup;

    if (!formGroup) return true;

    return (
      (formGroup.controls['start'].invalid && formGroup.controls['start'].touched) ||
      (formGroup.controls['end'].invalid && formGroup.controls['end'].touched)
    );
  }

  constructor(
    private _cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.formGroup = this._newFg();
  }

  private _newFg() {
    const start = Helper.reactiveForms.control<Date>(undefined, this.controlInfo.required ? [Helper.reactiveForms.validatos.required] : []);
    const end = Helper.reactiveForms.control<Date>(undefined, this.controlInfo.required ? [Helper.reactiveForms.validatos.required] : []);

    const subs: Subscription = combineLatest([
      start.valueChanges.pipe(startWith(start.value)),
      end.valueChanges.pipe(startWith(end.value)),
    ]).pipe(
      finalize(() => subs.unsubscribe()),
    ).subscribe(([s, e]) => {
      if (s && e) this.parentFormGroup.controls[this.controlInfo.name].patchValue([s, e]);
    });

    return new FormGroup({ start, end });
  }

}
